import { render } from "./HorseEditDocumentsTable.vue?vue&type=template&id=d56545b4"
import script from "./HorseEditDocumentsTable.vue?vue&type=script&lang=js"
export * from "./HorseEditDocumentsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__